import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {doesAgentTypeSupportTargetItem} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import {DataCaptureAgentState} from 'llm/data-capture/DataCaptureTypes';

export interface TargetItemInfo {
  itemId: string;
}

/**
 * Extracts the target item from application state for chats targeting an existing item.
 * For example, in Compose over Entries, this returns the entry being edited.
 *
 * Only applies to agents that support entry-backed target items; returns null for all other agent types.
 * Returns null if the chat is not targeting an existing entry (e.g. if it uses a draft instead).
 */
export function getTargetItem(
  agentType: AgentType | null,
  applicationState: object | null
): TargetItemInfo | null {
  if (agentType == null || !doesAgentTypeSupportTargetItem(agentType)) {
    return null;
  }
  const state = applicationState as DataCaptureAgentState | null;
  if (state?.target?.type === 'EXISTING_ENTRY') {
    return {itemId: state.target.entry_id};
  }
  return null;
}
